import { AccountApplicationUrlConstant } from 'src/constants';
import {
  GetAccountApplicationDto,
  AccountApplicationDocumentDto,
  AccountApplicationDto,
  UpdateAccountApplicationDocumentDto,
  UploadAccountApplicationDocumentDto,
  DownloadAccountApplicationDocumentDto,
  DownloadAccountApplicationDocumentResponseDto,
  DeleteAccountApplicationDocumentDto,
  UpdateAccountApplicationDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { httpRequest, replacePlaceholders, WithAuthToken } from 'src/utils';

export class AccountApplicationApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async retrieve({ params, authToken }: WithAuthToken<GetAccountApplicationDto>): Promise<AccountApplicationDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.RETRIEVE, params);

    return httpRequest<AccountApplicationDto>({
      method: 'GET',
      url,
      authToken,
    });
  }

  async update({
    params,
    body,
    authToken,
  }: WithAuthToken<UpdateAccountApplicationDto>): Promise<AccountApplicationDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.UPDATE, params);

    return httpRequest<AccountApplicationDto>({
      method: 'PUT',
      url,
      body,
      authToken,
    });
  }

  async uploadDocument({
    params,
    body,
    authToken,
    onProgress,
  }: WithAuthToken<UploadAccountApplicationDocumentDto> & {
    onProgress?: (percent: number) => void;
  }): Promise<AccountApplicationDocumentDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.UPLOAD_DOCUMENT, params);

    return httpRequest<AccountApplicationDocumentDto>({
      method: 'POST',
      url,
      body,
      authToken,
      onUploadProgress: onProgress,
    });
  }

  async downloadDocument({ params, authToken }: WithAuthToken<DownloadAccountApplicationDocumentDto>): Promise<Blob> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.DOWNLOAD_DOCUMENT, params);

    const result = await httpRequest<DownloadAccountApplicationDocumentResponseDto>({
      method: 'GET',
      url,
      authToken,
    });

    return httpRequest<Blob>({
      method: 'GET',
      url: result.downloadUrl,
    });
  }

  async updateDocument({
    params,
    body,
    authToken,
    onProgress,
  }: WithAuthToken<UpdateAccountApplicationDocumentDto> & {
    onProgress?: (percent: number) => void;
  }): Promise<AccountApplicationDocumentDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.UPDATE_DOCUMENT, params);

    return httpRequest<AccountApplicationDocumentDto>({
      method: 'PUT',
      url,
      body,
      authToken,
      onUploadProgress: onProgress,
    });
  }

  async deleteDocument({ params, authToken }: WithAuthToken<DeleteAccountApplicationDocumentDto>): Promise<void> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.DELETE_DOCUMENT, params);

    return httpRequest<void>({
      method: 'DELETE',
      url,
      authToken,
    });
  }
}
